const sortByDate = (data, isArrowToggled, address) => {
  const getNestedProperty = (data, address) => {
    return address.reduce((obj, key) => obj && obj[key], data);
  };
  let sortedData = data.slice().sort((a, b) => {
    let aData = getNestedProperty(a, address);
    let bData = getNestedProperty(b, address);

  
    let aTime = aData ? new Date(aData).getTime() : null;
    let bTime = bData ? new Date(bData).getTime() : null;



    // Move invalid/null dates to bottom
    if (!aTime && !bTime) return 0;
    if (!aTime) return 1;   // a goes down
    if (!bTime) return -1;  // b goes down

     // Normal sorting
    return isArrowToggled ? bTime - aTime : aTime - bTime;
  });
  return sortedData;
};
export default sortByDate;
